export default __webpack_public_path__ + "static/media/vc7.7285aaf2.jpg";